export default [
  {
    path: '/release',
    name: 'Release',
    component: () => import('@/views/release/index.vue'),
    meta: {
      auth: true,
      title: '释放',
      keepAlive: true,
      headerTheme: 'dark',
    }
  }
]

